import React from 'react';
import { BookOpenIcon, PrinterIcon, SlidersHorizontalIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { offer } from '../data/offer';
import { formattedPrice } from '../utils/checkout';
const badges = ['FORMAT PDF', 'À IMPRIMER OU À PROJETER', 'EN FRANÇAIS', '5 BONUS INCLUS'];
const steps = [{
  icon: BookOpenIcon,
  label: '1. Choisissez vos ressources'
}, {
  icon: PrinterIcon,
  label: '2. Imprimez ou projetez'
}, {
  icon: SlidersHorizontalIcon,
  label: '3. Adaptez à votre groupe'
}];
export function PricingSection() {
  const price = formattedPrice();
  return <section id="offer" aria-labelledby="offer-title" className="scroll-mt-9 bg-white px-4 py-12 md:py-20" data-id="element-239" data-mp="1x99jy7f9f5b0">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-240" data-mp="2271n5xlcudui">
        <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal-ink" data-id="element-241" data-mp="2v8przunn6h9">L’OFFRE</p>
        <h2 id="offer-title" className="text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-242" data-mp="7utlm1ej2ypr">
          La collection MUSIQUE PRÊTE
        </h2>
        <p className="mx-auto mb-12 mt-4 max-w-xl text-sm leading-relaxed text-slate-600" data-id="element-243" data-mp="1hpy9zzx61aqp">
          La collection complète&nbsp;: 10 tomes, 600 pages et 5 bonus inclus.
        </p>
        <div className="relative mx-auto max-w-xl rounded-3xl border-2 border-brand-teal bg-white p-6 pt-10 shadow-lg md:p-10 md:pt-12" data-id="element-244" data-mp="1cosgw0zlflgn">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-navy px-5 py-2 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-245" data-mp="25g2d866fz8h6">
            MUSIQUE PRÊTE
          </div>
          <div className="space-y-4 text-left" data-id="element-246" data-mp="1vfjlkp8mynop">
            <OfferLine label="10 tomes principaux" detail="600 pages hors bonus" data-id="element-247" data-mp="1rgar1i5ruls3" />
            <OfferLine label="5 bonus complémentaires" detail="Inclus" data-id="element-248" data-mp="k27p4zf7h7ck" />
            <div className="flex items-center justify-between gap-4 border-t border-brand-line pt-5 text-sm font-bold" data-id="element-249" data-mp="k03abmfrqnxi">
              <span data-id="element-250" data-mp="hhrtmzpwf1o7">FORMAT</span>
              <span className="text-slate-600" data-id="element-251" data-mp="hhi2v9x14qhg">PDF en français</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-line py-7" data-id="element-252" data-mp="mh4czahk9qm1">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand-teal-ink" data-id="element-253" data-mp="7jlsikbx1zke">TARIF</p>
            {price && <>
                <p className="mt-2 text-6xl font-extrabold tracking-tight text-brand-navy md:text-7xl" data-id="element-254" data-mp="chdnjn7uy1st">{price}</p>
                <p className="mt-3 text-sm font-bold text-brand-teal-ink" data-id="element-255" data-mp="3uvd38bwm25b1">10 tomes + 5 bonus inclus</p>
                {offer.oneTimePayment && <p className="mt-1 text-xs text-slate-600" data-id="element-256" data-mp="3kyi5hv85w8xt">(paiement unique)</p>}
              </>}
          </div>
          <ul className="mb-6 flex flex-wrap items-center justify-center gap-2" data-id="element-257" data-mp="3px1obmrgl4ly">
            {badges.map(badge => <li key={badge} className="rounded-full bg-brand-ivory px-3 py-1.5 text-[9px] font-extrabold uppercase tracking-[0.1em] text-brand-navy" data-id="element-258" data-mp="3bz3emuo31wcs">
                {badge}
              </li>)}
          </ul>
          <CTAButton target="checkout" className="w-full" data-id="element-259" data-mp="2scjpstppf1ng" />
          <ul className="mt-6 grid grid-cols-3 gap-2 border-t border-brand-line pt-5" data-id="element-260" data-mp="2se38ss2qvqsx">
            {steps.map(({
            icon: StepIcon,
            label
          }) => <li key={label} className="flex flex-col items-center gap-1.5 text-center" data-id="element-261" data-mp="31cf77g9ursvx">
                <StepIcon className="h-5 w-5 text-brand-teal" strokeWidth={1.6} aria-hidden="true" data-id="element-262" data-mp="3g9fnmnmlg1f3" />
                <span className="text-[10px] font-semibold leading-tight text-brand-navy md:text-[11px]" data-id="element-263" data-mp="3bbe7obkgsi7u">{label}</span>
              </li>)}
          </ul>
          <p className="mt-5 text-xs font-bold text-slate-600" data-id="element-264" data-mp="3p43swds65j3w">
            Collection numérique&nbsp;: fichiers PDF uniquement, aucun envoi physique.
          </p>
        </div>
      </Reveal>
    </section>;
}
function OfferLine({
  label,
  detail
}: {
  label: string;
  detail: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-line pb-4 text-sm" data-id="element-265" data-mp="3tz9gdh17z5u3">
      <span className="font-medium" data-id="element-266" data-mp="hw9owb972v5g">{label}</span>
      <span className="text-right font-bold text-brand-navy" data-id="element-267" data-mp="lymk45qbfanz">{detail}</span>
    </div>;
}